import $ from 'jquery';
import 'slick-carousel';

const initSlider = () => {
    $('[data-component="slider"]').each(function () {
        $(this).slick({
            rows: 1,
            dots: false,
            arrows: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 5000,
            variableWidth: false,
        });
    });
};

export default initSlider;